import React, { useEffect, useState } from "react";
import axios from "axios";
import InputOption from "../../../component/InputOption/InputOption";


const AccountComponent = ({ label, onAccountUpdated, onAmountUpdated, items }) => {
    const [optionAccount, setOptionAccount] = useState([]);
    const [optionTax, setOptionTax] = useState([]);

    const [rows, setRows] = useState([
        {
            account: "",
            description: "",
            amount: 0,
            tax: 0,
            tax_id: "",
            tax_name: ""
        },
    ]);

    const [error, setError] = useState(null);

    const handleChange = (index, field, value) => {
        const updatedRows = [...rows];
        updatedRows[index][field] = value;
        setRows(updatedRows);
    };

    const addRow = () => {
        setRows([
            ...rows,
            {
                account: "",
                description: "",
                amount: 0,
                tax: 0,
                tax_id: "",
                tax_name: ""
            },
        ]);
    };

    const removeRow = (index) => {
        const updatedRows = rows.filter((_, i) => i !== index);
        setRows(updatedRows);
    };

    const calculateRowTotal = (row) => {
        return row.amount;
    };

    const calculateRowTax = (row) => {
        const taxAmount =
            (row.amount * row.tax) / 100;
        return taxAmount;
    };

    const calculateSubtotal = (type) => {
        if (type == 'amount') {
            return rows.reduce((total, row) => total + calculateRowTotal(row), 0);
        } else if (type == 'tax') {
            return rows.reduce((total, row) => total + calculateRowTax(row), 0);
        }
        return 0;
    };

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_ACCOUNT_EXPENSES = "api/erpppsu/account/expense";
    const PATH_TAX = "api/erpppsu/product/optiontaxes";

    const fetchData = async (URL) => {
        try {
            const response = await axios.get(URL);
            return response.data; // Return only the data from the response
        } catch (err) {
            setError("Failed to fetch data. Please try again later.");
            console.log(err);
        } finally {
            // setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(`${BASE_URL}${PATH_ACCOUNT_EXPENSES}`).then((data) => {
            setOptionAccount(data);
        });

        fetchData(`${BASE_URL}${PATH_TAX}`).then((data) => {
            setOptionTax(data);
        });
    }, []);

    useEffect(() => {
        onAccountUpdated(rows);
        onAmountUpdated(calculateSubtotal('amount'));
    }, [rows])

    useEffect(() => {
        if (items && items.length > 0) {
            const formattedRows = items.map((item) => ({
                account: item.account,
                description: item.description,
                amount: parseFloat(item.amount),
                tax: parseFloat(item.tax),
                tax_id: item.tax_id,
                tax_name: item.tax_name,
            }));

            setRows(formattedRows);
        }
    }, [items]);

    return (
        <div className="relative max-w-full p-4 overflow-x-auto">
            <div className="max-w-full overflow-x-auto">
                <table className="w-full border-collapse border border-gray-200">
                    <thead className="bg-gray-100">
                        <tr>
                            <th className="w-1/5 min-w-40 p-2 border border-gray-200">{label}</th>
                            <th className="w-1/5 min-w-40 p-2 border border-gray-200">Deskripsi</th>
                            <th className="w-1/5 min-w-40 p-2 border border-gray-200">Nominal</th>
                            <th className="w-1/5 min-w-40 p-2 border border-gray-200">Pajak (%)</th>
                            <th className="w-1/5 min-w-40 p-2 border border-gray-200">Jumlah</th>
                            <th className="w-1/5 p-2 border border-gray-200"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, index) => (
                            <tr key={index}>
                                <td className="p-2 border border-gray-200">
                                    <InputOption
                                        label="Pilih Akun"
                                        data={optionAccount}
                                        placeholder="Ketik disini"
                                        defaultValue={row?.account}
                                        onChange={(value) => {
                                            handleChange(index, "account", value)
                                        }}
                                        returnKey="code"
                                    />
                                </td>
                                <td className="p-2 border border-gray-200">
                                    <input
                                        type="text"
                                        className="w-full border border-gray-300 rounded-md p-2"
                                        value={row.description}
                                        onChange={(e) =>
                                            handleChange(index, "description", e.target.value)
                                        }
                                        placeholder="Masukkan keterangan"
                                    />
                                </td>
                                <td className="p-2 border border-gray-200">
                                    <input
                                        type="number"
                                        className="w-full border border-gray-300 rounded-md p-2"
                                        value={row.amount}
                                        onChange={(e) =>
                                            handleChange(index, "amount", parseFloat(e.target.value))
                                        }
                                        min="0"
                                    />
                                </td>
                                <td className="p-2 border border-gray-200">
                                    <select
                                        className="w-full border border-gray-300 rounded-md p-2"
                                        value={row.tax_id}
                                        onChange={(e) => {
                                            const tax = optionTax.find(item => item.id === e.target.value);
                                            if (tax) {
                                                handleChange(index, "tax_id", tax.id);
                                                handleChange(index, "tax_name", tax.name);
                                                handleChange(index, "tax", parseInt(tax.rate));
                                            } else {
                                                handleChange(index, "tax_id", null);
                                                handleChange(index, "tax_name", "-");
                                                handleChange(index, "tax", 0);
                                            }
                                        }}
                                    >
                                        <option value="">Pilih Pajak</option>
                                        {optionTax.map((tax) => (
                                            <option key={tax.id} value={tax.id}>
                                                {tax.name}
                                            </option>
                                        ))}
                                    </select>
                                </td>
                                <td className="p-2 border border-gray-200">
                                    Rp {calculateRowTotal(row).toLocaleString("id-ID", {
                                        minimumFractionDigits: 2,
                                    })}
                                </td>
                                <td className="p-2 border border-gray-200 text-center">
                                    <button
                                        onClick={() => removeRow(index)}
                                        className="text-red-500 hover:text-red-700"
                                    >
                                        &times;
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <button
                type="button"
                onClick={addRow}
                className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
            >
                Tambah Biaya
            </button>
        </div>
    );
};

export default AccountComponent;
